import React, { useCallback, useMemo, useState } from 'react';
import Button from '@msi/cobalt-react/button';
import Icon from '@msi/cobalt-react/icon';
import { Modal, ModalHeader, ModalContent, ModalActions} from '@msi/cobalt-react/modal';
import '../Table/ApiTable.css'

interface DeleteApiModalProps {
  trigger?: (handlers: { onClick: (e?: React.MouseEvent) => void }) => React.ReactNode;
  onDelete: (id?: string, e?: React.MouseEvent) => void;
  apiId?: string;
  apiName?: string;
}

const DeleteApiModal: React.FC<DeleteApiModalProps> = ({trigger, onDelete, apiId, apiName}) => {
    const [show, setShow] = useState(false);
    const modalStyle = useMemo(() => ({
      overlay: {
        zIndex: 4000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      },
      content: {
        zIndex: 4001,
        inset: 'auto',
        position: 'relative',
        border: 'none',
        padding: 0,
        overflow: 'visible',
        width: 'min(520px, calc(100vw - 48px))',
        maxWidth: '520px',
        margin: '0 auto',
        background: 'transparent',
      },
    }), []);
    const onClick = useCallback((e?: React.MouseEvent) => {
      if (e) e.stopPropagation();
      setShow(true);
    }, [setShow]);

    const onClose = useCallback((e?: React.MouseEvent) => {
      if (e) e.stopPropagation();
      setShow(false);
    }, [setShow]);

    const handleDelete = useCallback((e?: React.MouseEvent) => {
      if (e) e.stopPropagation();
      onDelete(apiId);
      setShow(false);
    }, [onDelete, apiId, setShow]);

    const renderTrigger = () => {
      if (typeof trigger === 'function') {
        return trigger({ onClick });
      }

      return (
        <Button text="" className="icon-button" onClick={onClick}>
          <Icon name="ic_trash" size={24} color="primary" className="settingsIcons"/>
        </Button>
      );
    };

    return <div>
            {renderTrigger()}
            <Modal handleCloseModal={onClose} showModal={show} style={modalStyle}>
              <ModalHeader>Delete API</ModalHeader>
              <ModalContent>
                You are about to permanently remove the following API. This action cannot be undone.
                {apiName && (
                  <div style={{ marginTop: '12px', fontWeight: 600 }}>
                    {apiName}
                  </div>
                )}
              </ModalContent>
              <ModalActions>
                <Button text="Delete" onClick={handleDelete} variant="primary" />
                <Button text="Cancel" onClick={onClose} />
              </ModalActions>
            </Modal>
          </div>;
}
export default DeleteApiModal;
